import { SegmentLinkModel, SegmentTransferModel } from '@/lib/models/segment/types';
import { transformEvent } from '@/lib/transformers/event';
import { getSegmentEmissions } from '@/lib/transformers/segment/utils/get-segment-emissions';
import { RouteLinkSegmentApiV4Interface, RouteTransferSegmentApiV4Interface } from '@/types/api-types';
import { generateId } from '@/utils/helpers';

const getBaseSegmentData = ({
  segment,
}: {
  segment: RouteTransferSegmentApiV4Interface | RouteLinkSegmentApiV4Interface;
}) => {
  const { fromId, durationSeconds } = segment;
  const id = generateId();

  return {
    id,
    fromId,
    durationSeconds,
  };
};

export const transformTransferSegment = ({
  segment,
}: {
  segment: RouteTransferSegmentApiV4Interface;
}): SegmentTransferModel => {
  return {
    ...getBaseSegmentData({ segment }),
    routeType: segment.routeType,
    transferType: segment.transferType,
  };
};

export const transformLinkSegment = ({ segment }: { segment: RouteLinkSegmentApiV4Interface }): SegmentLinkModel => {
  const {
    pathIds,
    featureSet,
    carrierIds = [],
    frequency,
    distanceKm,
    toId,
    events = [],
    vehicles,
    lineIds,
    departureOTP,
    arrivalOTP,
  } = segment;
  const emissions = getSegmentEmissions(segment);
  const reliability = {
    departureOTP,
    arrivalOTP,
  };

  return {
    ...getBaseSegmentData({ segment }),
    distanceKm,
    toId,
    events: events.map((event) => transformEvent(event)),
    vehicles,
    carrierIds,
    frequency,
    routeType: segment.routeType,
    featureSet,
    emissions,
    pathIds,
    lineIds,
    ...(departureOTP || arrivalOTP ? { reliability } : {}),
  };
};

export const transformSegment = ({
  segment,
}: {
  segment: RouteTransferSegmentApiV4Interface | RouteLinkSegmentApiV4Interface;
}): SegmentLinkModel | SegmentTransferModel => {
  if ('distanceKm' in segment) {
    return transformLinkSegment({ segment });
  }

  return transformTransferSegment({ segment });
};
